export const FIND_IDU_ROUTES = {
  FIND_IDU_SELECTION: '/find-idu',
  FIND_IDU_FORM_OVERVIEW: '/find-idu-form-overview',
  FIND_IDU_SEARCH_VERIFICATION: '/find-idu-search-verification'
}

export const FIND_IDU = 'findIDU'